/* eslint-disable @typescript-eslint/no-explicit-any */
import { Memo } from '@/hoc/Memo'
import { cn } from '@bem-react/classname'
import { saveAs } from 'file-saver'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import * as XLSX from 'xlsx'
import excel from '../../assets/icons/excel.svg'
import './ExportExcelButtonSuperadmin.scss'

const cnExport = cn('Export')

export interface BtnSchema {
  data?: any
}

export const ExportExcelButtonSuperadmin: FC<BtnSchema> = Memo(
  ({ data }: BtnSchema) => {
    const { t } = useTranslation('translation')

    const headerValues = [
      t('Version'),
      t('Serial Number'),
      t('Activation Date'),
      t('Expiration Date'),
      t('Company Code'),
      t('Status'),
      t('Customer Name'),
      t('Customer Surname'),
      t('Farm Name'),
      t('Customer Country'),
      t('Customer Email'),
      t('Customer Phone'),
      t('Customer Address'),
      t('Note'),
      t('User Email'),
      t('Used Discount Code'),
      t('Transaction Date'),
      t('Renew'),
      t('Reseller ID'),
    ]

    const handleExport = () => {
      const workbook = XLSX.utils.book_new()
      const worksheetOptions = {
        header: headerValues.map((value, index) => {
          return data[index] ? value : ''
        }),

        skipHeader: false,
        origin: 'A1', // Начальная ячейка для заполнения данных
      }

      const worksheet = XLSX.utils.sheet_add_json(worksheetOptions, data, {
        skipHeader: true,
        origin: 'A2',
      })

      worksheet['A1'] = { v: headerValues[0], t: 's' }
      worksheet['B1'] = { v: headerValues[1], t: 's' }
      worksheet['C1'] = { v: headerValues[2], t: 's' }
      worksheet['D1'] = { v: headerValues[3], t: 's' }
      worksheet['E1'] = { v: headerValues[4], t: 's' }
      worksheet['F1'] = { v: headerValues[5], t: 's' }
      worksheet['G1'] = { v: headerValues[6], t: 's' }
      worksheet['H1'] = { v: headerValues[7], t: 's' }
      worksheet['I1'] = { v: headerValues[8], t: 's' }
      worksheet['J1'] = { v: headerValues[9], t: 's' }
      worksheet['K1'] = { v: headerValues[10], t: 's' }
      worksheet['L1'] = { v: headerValues[11], t: 's' }
      worksheet['M1'] = { v: headerValues[12], t: 's' }
      worksheet['N1'] = { v: headerValues[13], t: 's' }
      worksheet['O1'] = { v: headerValues[14], t: 's' }
      worksheet['P1'] = { v: headerValues[15], t: 's' }
      worksheet['Q1'] = { v: headerValues[16], t: 's' }
      worksheet['R1'] = { v: headerValues[17], t: 's' }
      worksheet['S1'] = { v: headerValues[18], t: 's' }

      worksheet['!cols'] = [
        { width: 18 },
        { width: 20 },
        { width: 30 },
        { width: 30 },
        { width: 15 },
        { width: 10 },
        { width: 30 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 35 },
        { width: 20 },
        { width: 35 },
        { width: 40 },
        { width: 40 },
        { width: 40 },
        { width: 40 },
        { width: 40 },
        { width: 40 },
      ]

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet')
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      })
      const excelData = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(excelData, 'licenses.xlsx')
    }

    return (
      <div className={cnExport('btn')}>
        <button onClick={handleExport}>
          <img src={excel} alt='excel' />
        </button>
      </div>
    )
  },
)
